const StatsBarChart = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.1699 3C10.3415 3 9.66992 3.67157 9.66992 4.5V19.501C9.66992 20.3294 10.3415 21.001 11.1699 21.001H12.8399C13.6683 21.001 14.3399 20.3294 14.3399 19.501V4.5C14.3399 3.67157 13.6683 3 12.8399 3H11.1699Z"
      fill="currentColor"
    />
    <path
      d="M4.5 13.001C3.67157 13.001 3 13.6725 3 14.501V19.501C3 20.3294 3.67157 21.001 4.5 21.001H6.17C6.99843 21.001 7.67 20.3294 7.67 19.501V14.501C7.67 13.6725 6.99843 13.001 6.17 13.001H4.5Z"
      fill="currentColor"
    />
    <path
      d="M16.3398 9.5C16.3398 8.67157 17.0114 8 17.8398 8H19.5098C20.3383 8 21.0098 8.67157 21.0098 9.5V19.501C21.0098 20.3294 20.3383 21.001 19.5098 21.001H17.8398C17.0114 21.001 16.3398 20.3294 16.3398 19.501V9.5Z"
      fill="currentColor"
    />
  </svg>
)

export default StatsBarChart
